import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  string,
  object,
  boolean,
} from 'libs/form';
import { SelectType } from 'types/selectType';

export interface TimezoneFormType {
  timezone?: SelectType<string>;
  isAutomaticTimezone?: boolean;
}

export const getSchema = (): ObjectSchema<TimezoneFormType> =>
  object({
    isAutomaticTimezone: boolean().required(),
    timezone: object({
      value: string().required(),
      label: string().required(),
    })
      .when('isAutomaticTimezone', {
        is: false,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.notRequired().nullable(),
      })
      .default(null),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<TimezoneFormType>();

export type FormErrors = FormErrorsBase<TimezoneFormType>;
